/** @jsx jsx */
import { jsx, Container, Box, Flex } from 'theme-ui';
import { keyframes } from '@emotion/core';
import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import PriceCard from 'components/price-card';
import ButtonGroup from 'components/button-group';
import SectionHeader from 'components/section-header';
import { IoIosCheckmarkCircle, IoIosCloseCircle } from 'react-icons/io';

const packages = {
  free: [
    {
      id: 1,
      header: 'Free Webinar',
      name: 'New opportunities in Canada 🇨🇦 ',
      description: 'By Rizwan Vadakkan',
      buttonText: 'Register Now',
      
      points: [
        {
          id: 1,
          icon: <IoIosCheckmarkCircle />,
          text: 'New courses to consider.',
          isAvailable: true,
        },
        {
          id: 2,
          icon: <IoIosCheckmarkCircle />,
          text: "Top universities.",
          isAvailable: true,
        },
        {
          id: 3,
          icon: <IoIosCheckmarkCircle />,
          text: 'Applying for scholarships.',
          isAvailable: true,
        },
        {
          id: 4,
          icon: <IoIosCloseCircle />,
          text: 'IELTS prepration plans. ',
          isAvailable: true,
        },
      ],
    },
    {
      id: 2,
      name: 'Building your career path.',
      description: 'For High School Students',
      priceWithUnit: '',
      buttonText: 'Register now',
      anotherOption: 'on 15 April 2022',
      text: 'on 15 April 2022',
      points: [
        {
          id: 1,
          icon: <IoIosCheckmarkCircle />,
          text: 'Finding new opportunities',
          isAvailable: true,
        },
        {
          id: 2,
          icon: <IoIosCheckmarkCircle />,
          text: "Focus based approach",
          isAvailable: true,
        },
        {
          id: 3,
          icon: <IoIosCheckmarkCircle />,
          text: 'Education Support Tools',
          isAvailable: true,
        },
        {
          id: 4,
          icon: <IoIosCheckmarkCircle />,
          text: 'Passion to Profession ',
          isAvailable: true,
        },
      ],
    },
    {
      id: 3,
      header: 'Suggested',
      headerIcon: <IoIosCheckmarkCircle />,
      name: 'IELTS Tips and Study Plan',
      description: 'For IELTS Exam Preprations',
      priceWithUnit: '',
      buttonText: 'Register Now',
      anotherOption: 'Every Thursday',
      points: [
        {
          id: 1,
          icon: <IoIosCheckmarkCircle />,
          text: 'Topics to cover.',
          isAvailable: true,
        },
        {
          id: 2,
          icon: <IoIosCheckmarkCircle />,
          text: "Scoring better on Listening session.",
          isAvailable: true,
        },
        {
          id: 3,
          icon: <IoIosCheckmarkCircle />,
          text: 'Creating a study plan.',
          isAvailable: true,
        },
        {
          id: 4,
          icon: <IoIosCheckmarkCircle />,
          text: 'Individual Practice Sessions ',
          isAvailable: true,
        },
      ],
    },
  ],
  paid: [
    {
      id: 1,
      name: 'Rizwan Vadakkan',
      description: 'International Education Consultant',
      buttonText: 'Book Now',
      priceWithUnit: '$5/Hour',
      points: [
        {
          id: 1,
          icon: <IoIosCheckmarkCircle />,
          text: "30 minutes Zoom Session.",
          isAvailable: true,
        },
        {
          id: 2,
          icon: <IoIosCheckmarkCircle />,
          text: 'Top countries to study.',
          isAvailable: true,
        },
        {
          id: 3,
          icon: <IoIosCheckmarkCircle />,
          text: 'Finalizing your course.',
          isAvailable: true,
        },
        {
          id: 4,
          icon: <IoIosCloseCircle />,
          text: 'Selecting University. ',
          isAvailable: true,
        },
      ],
    },
    {
      id: 2,
      name: 'Mohammed',
      description: 'Migration Consultant - 🇨🇦',
      priceWithUnit: '$5/Hour',
      buttonText: 'Book Now',
      
      points: [
        {
          id: 1,
          icon: <IoIosCheckmarkCircle />,
          text: '30 minutes Zoom Session',
          isAvailable: true,
        },
        {
          id: 2,
          icon: <IoIosCheckmarkCircle />,
          text: 'Migration Support Tools',
          isAvailable: true,
        },
        {
          id: 3,
          icon: <IoIosCheckmarkCircle />,
          text: "Procedures and Paperworks",
          isAvailable: true,
        },
        {
          id: 4,
          icon: <IoIosCheckmarkCircle />,
          text: 'Dos and Donts',
          isAvailable: true,
        },
      ],
    },
    {
      id: 3,
      header: 'Suggested',
      headerIcon: <IoIosCheckmarkCircle />,
      name: 'Personal Strategy Session',
      description: 'For Students',
      priceWithUnit: '$5/Hour',
      buttonText: 'Book Now',
      
      points: [
        {
          id: 1,
          icon: <IoIosCheckmarkCircle />,
          text: '30 minutes Zoom Session',
          isAvailable: true,
        },
        {
          id: 2,
          icon: <IoIosCheckmarkCircle />,
          text: 'Build your career strategy.',
          isAvailable: true,
        },
        {
          id: 3,
          icon: <IoIosCheckmarkCircle />,
          text: "Understand strength and weaknesses",
          isAvailable: true,
        },
        {
          id: 4,
          icon: <IoIosCheckmarkCircle />,
          text: 'Finding good opportunities ',
          isAvailable: true,
        },
      ],
    },
  ],
};

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    draggable: false,
  },
  tablet: {
    breakpoint: { max: 1023, min: 640 },
    items: 2,
    draggable: true,
  },
  mobile: {
    breakpoint: { max: 639, min: 0 },
    items: 1,
    draggable: true,
  },
};

export default function Package() {
  const { free, paid } = packages;
  const [state, setState] = useState({
    active: 'free',
    pricingPlan: free,
  });

  const handlePricingPlan = (plan) => {
    if (plan === 'paid') {
      setState({
        ...state,
        active: 'paid',
        pricingPlan: paid,
      });
    } else {
      setState({
        ...state,
        active: 'free',
        pricingPlan: free,
      });
    }
  };

  const sliderParams = {
    additionalTransfrom: 0,
    arrows: false,
    autoPlaySpeed: 3000,
    centerMode: false,
    className: '',
    slidesToSlide: 1,
    items: 3,
    containerClass: 'carousel-container',
    customButtonGroup: <ButtonGroup />,
    dotListClass: '',
    focusOnSelect: false,
    infinite: false,
    keyBoardControl: false,
    itemClass: '',
    minimumTouchDrag: 80,
    renderButtonGroupOutside: true,
    renderDotsOutside: false,
    responsive: responsive,
    showDots: false,
    sliderClass: '',
  };

  return (
    <section id="pricing" sx={{ variant: 'section.pricing' }}>
      <Container>
        <SectionHeader
          slogan="Consultation Plans"
          title="Free Webinars & Personal Strategy Session"
        />
        <Flex sx={styles.buttonGroup}>
          <Box sx={styles.buttonGroupInner}>
            <button
              className={state.active === 'free' ? 'active' : ''}
              type="button"
              aria-label="free"
              onClick={() => handlePricingPlan('free')}
            >
              Free Events
            </button>
            <button
              className={state.active === 'paid' ? 'active' : ''}
              type="button"
              aria-label="Paid"
              onClick={() => handlePricingPlan('paid')}
            >
              Paid Sessions
            </button>
          </Box>
        </Flex>
        <Box sx={styles.pricingWrapper} className="pricing__wrapper">
          <Carousel {...sliderParams}>
            {state.pricingPlan.map((packageData) => (
              <Box
                sx={styles.pricingItem}
                key={`${state.active}-card--key${packageData.id}`}
              >
                <PriceCard data={packageData} />
              </Box>
            ))}
          </Carousel>
        </Box>
      </Container>
    </section>
  );
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeIn2 = keyframes`
  from {
    transform: translateY(50%);
    opacity: 0;
  }
  to {
		transform: translateY(0);
    opacity: 1;
  }
`;
const styles = {
  pricingWrapper: {
    mb: '-40px',
    mt: '-40px',
    mx: -3,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    '&.pricing__wrapper .package__card': {
      '.package__header': {
        animation: `${fadeIn} 0.8s ease-in`,
      },
      'ul > li': {
        animation: `${fadeIn2} 0.7s ease-in`,
      },
      '.package__price': {
        animation: `${fadeIn2} 0.9s ease-in`,
      },
      button: {
        animation: `${fadeIn2} 1s ease-in`,
      },
    },
    '.carousel-container': {
      width: '100%',
      '> ul > li ': {
        display: 'flex',
      },
    },
    '.button__group': {
      display: ['flex', null, null, null, 'none'],
      mb: [4, null, null, null, 0],
    },
  },
  pricingItem: {
    mx: 3,
    display: 'flex',
    flexShrink: 0,
    flex: '1 1 auto',
  },
  buttonGroup: {
    justifyContent: 'center',
    mb: '7',
    mt: ['-15px', '-35px'],
    position: 'relative',
    zIndex: 2,
  },
  buttonGroupInner: {
    display: 'flex',
    padding: '7px',
    margin: '0 auto',
    borderRadius: '5px',
    backgroundColor: '#F7F8FB',
    button: {
      border: 0,
      padding: ['15px 20px', '15px 27px'],
      borderRadius: '5px',
      color: 'text',
      fontSize: [1, 2],
      lineHeight: 1.2,
      fontWeight: 500,
      backgroundColor: 'transparent',
      cursor: 'pointer',
      fontFamily: 'body',
      letterSpacing: '-0.24px',
      transition: 'all 0.3s',
      '&.active': {
        color: '#0f2137',
        backgroundColor: '#ffffff',
        boxShadow: '0 3px 4px rgba(38, 78, 118, 0.1)',
      },
      '&:focus': {
        outline: 0,
      },
    },
  },
};
